export function isLoggedIn() {
  try {
    const t = localStorage.getItem("token");
    if (!t) return false;

    const base64 = t.split(".")[1];
    const payload = JSON.parse(
      atob(base64.replace(/-/g, "+").replace(/_/g, "/"))
    );

    if (payload?.exp && Date.now() >= payload.exp * 1000) return false;
    return true;
  } catch {
    return !!localStorage.getItem("token");
  }
}